var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Flex } from '@creditas-ui/layout';
import { styled } from '@creditas-ui/system';
import * as React from 'react';
var ToastChevronRightIconElement = styled(Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 40px;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n"])));

var ToastChevronRightIcon = _ref => {
  var {
    variant = 'light'
  } = _ref;
  var color = variant === 'dark' ? '#ffffff' : '#000000';
  return /*#__PURE__*/React.createElement(ToastChevronRightIconElement, null, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 16L14 12L10 8",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { ToastChevronRightIcon };
//# sourceMappingURL=ToastChevronRightIcon.js.map